import { useQuery } from 'react-query';
import {
  getRosterFunctionsPreferred,
  RosterFunctionByCostCenterAndDate
} from 'RestAPIs/roster/functions';

const useGetRosterFunctionsPreferred = ({
  costCenterId,
  startDate,
  endDate
}: RosterFunctionByCostCenterAndDate) => {
  const { data, isFetching, isError, refetch } = useQuery(
    ['rosterFunctionsPreferred', 'list', costCenterId, startDate, endDate],
    async () => {
      const { data } = await getRosterFunctionsPreferred({
        costCenterId,
        startDate,
        endDate
      });
      return data;
    }
  );
  return { data, isFetching, isError, refetch };
};

export default useGetRosterFunctionsPreferred;
